<template>
  <div>

  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
import { getActionAuth } from '@/api/login';
export default {
  name: "auth",
  data(){
    return{

    }
  },
  created() {
      const item = {
        "scope":"",
        "client_id":"",
        "redirect_uri":"",
        "state":"",
        "response_type":""
      }

      const url = window.location.href;
      var query = decodeURIComponent(url).split("?")[1]; // 根据“?”切割数组，截取“?”之后的字符串
      var vars = query.split("&"); // 根据“&”切割成数组
      for (var i=0;i<vars.length;i++) {
          var pair = vars[i].split("=");
          if("scope" == pair[0]){
              item.scope=pair[1];
          }
          if("client_id"==pair[0]){
            item.client_id=pair[1];
          }
          if("redirect_uri"==pair[0]){
            item.redirect_uri=pair[1];
          }
          if("state"==pair[0]){
            item.state=pair[1];
          }
          if("response_type"==pair[0]){
            item.response_type=pair[1];
          }
      }
      if(getToken()){
          //获取页面路径上的参数
          getActionAuth(item).then(response => {

            var url = item.redirect_uri+"?code="+response.data.code+"&scope="+item.scope+"&state="+item.state+"&authuser=0&prompt=consent";
            console.log(url);
            window.open("http://101.133.141.184/ss?code="+response.data.code+"&scope="+item.scope+"&state="+item.state+"&authuser=0&prompt=consent")
            // window.location.href = url
            // window.location.replace(url);
            // console.log(item.redirect_uri+"?code="+response.data.code+"&scope="+item.scope+"&state="+item.state+"&authuser=0&prompt=consent");
          });
      }else{
          this.$router.push({
            path: '/login'
          })
      }
  }
}
</script>

<style scoped>

</style>